const signatureDims = {
	width: 128,
	height: 20,
};

export { signatureDims };
